export default __webpack_public_path__ + "static/media/top1.de5d8041.png";